module.exports = __webpack_public_path__ + "img/icon-complementos-de-pago.031cc442.svg";